<div class="holder mat-typography">
  <form [formGroup]="form" class="time-from">
    <h1 mat-dialog-title>Set a validity Period</h1>
    <div class="time" fxLayout="column">
      <h3>Time zone</h3>
      <div fxLayout="row wrap">
        <mat-form-field fxFlex="75">
          <mat-label>Country</mat-label>
          <input
            matInput
            formControlName="country"
            [matAutocomplete]="countryAuto"
          />
          <button
            *ngIf="form.value.country"
            matSuffix
            mat-icon-button
            (click)="resetInput()"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete
            autoActiveFirstOption
            #countryAuto="matAutocomplete"
            [displayWith]="displayCountry"
          >
            <mat-option
              *ngFor="let option of filteredCountries | async"
              [value]="option"
              (click)="setTimezone(option)"
            >
              <div class="mat-option-inside">
                {{ option!.name | translate }}
                <h3 mat-line>{{ option.defaultTimezone }}</h3>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <div fxFlex="25" class="timezone-summary">
          <div mat-line>
            {{
              form.value.timezone.country
                ? (form.value.timezone.country.name | translate)
                : "Default"
            }}
            - {{ form.value.timezone.value }}
          </div>
          <div mat-line>
            <mat-chip (removed)="resetTimeZone()">
              GMT
              {{ offset }}
              <button matChipRemove *ngIf="form.value.timezone.country">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <h3>Starting time</h3>
      <div
        formGroupName="startDate"
        fxLayout="row wrap"
        fxLayoutGap="16px grid"
      >
        <mat-form-field fxFlex="50">
          <mat-label>Date</mat-label>
          <input
            matInput
            formControlName="date"
            [matDatepicker]="pickerStart"
          />
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerStart"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>
        <mat-form-field fxFlex="25">
          <mat-label>Time</mat-label>
          <input matInput formControlName="time" />
          <mat-hint>hh:mm</mat-hint>
        </mat-form-field>
        <mat-checkbox
          class="example-margin"
          formControlName="inclusive"
          fxFlex="25"
          >Is inclusive ?</mat-checkbox
        >
      </div>
      <mat-divider></mat-divider>
      <h3>
        Ending time
        <div class="optional">Optional</div>
      </h3>

      <div formGroupName="endDate" fxLayout="row wrap" fxLayoutGap="16px grid">
        <mat-form-field fxFlex="50">
          <mat-label>Date</mat-label>
          <input matInput formControlName="date" [matDatepicker]="pickerEnd" />
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerEnd"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
        <mat-form-field fxFlex="25">
          <mat-label>Time</mat-label>
          <input matInput maxlength="5" #endTime formControlName="time" />
          <mat-hint>hh:mm</mat-hint>
        </mat-form-field>
        <mat-checkbox
          fxFlex="25"
          class="example-margin"
          formControlName="inclusive"
          >Is inclusive ?</mat-checkbox
        >
      </div>
    </div>
    <div class="actions">
      <button mat-button (click)="notSelected()">Cancel</button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="form.invalid"
        (click)="onSubmit()"
      >
        Save
      </button>
    </div>
  </form>
  <!-- <header>
    <h3>Timezone</h3>
    <mat-list>
      <mat-list-item>
        <div mat-line>
          {{
            form.value.timezone.country
              ? (form.value.timezone.country.name | translate)
              : "Default"
          }}
        </div>
        <div mat-line>
          {{ form.value.timezone.value }}
        </div>
        <div mat-line>
          <mat-chip (removed)="resetTimeZone()">
            GMT
            {{ offset }}
            <button matChipRemove *ngIf="form.value.timezone.country">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </div>
      </mat-list-item>
    </mat-list>
    <h3>Start</h3>
    <mat-list>
      <mat-list-item>
        <div mat-line>
          {{
            (form.value.startDate.date | date : "dd MMM YYYY") || "Not setted"
          }}
        </div>
        <div mat-line *ngIf="startDateLocal">
          {{ form.value.startDate.time }}
        </div>
      </mat-list-item>
      <mat-list-item *ngIf="startDateLocal">
        <div mat-line>
          {{ startDateLocal | date : "dd MMM YYYY" }}
        </div>
        <div mat-line>
          {{ startDateLocal | date : "HH:mm" }}
        </div>
        <h3 mat-suffix>In Local Time</h3>
      </mat-list-item>
    </mat-list>
    <h3>End</h3>
    <mat-list>
      <mat-list-item>
        <div mat-line>
          {{ (form.value.endDate.date | date : "dd MMM YYYY") || "Not setted" }}
        </div>
        <div mat-line *ngIf="endDateLocal">{{ form.value.endDate.time }}</div>
      </mat-list-item>
      <mat-list-item *ngIf="endDateLocal">
        <div mat-line>
          {{ endDateLocal | date : "dd MMM YYYY" }}
        </div>
        <div mat-line>
          {{ endDateLocal | date : "HH:mm" }}
        </div>
        <h3 mat-suffix>In Local Time</h3>
      </mat-list-item>
    </mat-list>
  </header> -->
</div>
